// extracted by mini-css-extract-plugin
export default {"meals":"AvailableMeals_meals__1qX6E","meals-up":"AvailableMeals_meals-up__Gvq4E"};